import { Pipe, PipeTransform } from '@angular/core';
import { SortDescriptor } from 'devextreme/data';
import { SortDirectionType } from '@ag-common-lib/lib/models/utils/sorting.model';

@Pipe({
  name: 'sortingOrderByField',
})
export class SortingOrderByFieldPipe<T extends string> implements PipeTransform {
  transform(field: T, sortDescriptor: SortDescriptor<string>[]): SortDirectionType | undefined {
    const descriptor = sortDescriptor.find(d => d['selector'] === field);
    if (!descriptor) {
      return undefined;
    }
    return descriptor?.['desc'] ? 'desc' : 'asc';
  }
}
